//create your forceUpdate hook
import {useCallback, useState} from "react";

export function useForceUpdate() {
	const [value, setValue] = useState(0); // integer state
	return useCallback( () => setValue(value => ++value), [true]); // update the state to force render
}